<i
  *ngIf="quote"
  class="d-inline-block text-truncate quote"
>
  "{{ quote }}"
</i>